import React from "react";
import PageHeader from "../Components/common/PageHeader";
import { useTranslation } from "react-i18next";
import Galeri from "../Components/common/Galeri";
import SEO from "../Components/common/SEO";
// import Spacer2 from "../Components/common/Spacer2";

function GaleriPage() {
  const { t } = useTranslation();
  const siteUrl = 'https://seymenkimya.com';
  const pageUrl = `${siteUrl}/galeri`;

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    'name': 'Galeri',
    'url': pageUrl,
    'mainEntity': {
      '@type': 'ImageGallery',
      'name': 'Ürün Galerisi',
      'url': pageUrl
    }
  };

  return (
    <>
      <SEO
        title="Galeri | Seymen Kimya"
        description="Seymen Kimya ürün ve kurumsal görselleri galeride keşfedin."
        canonical={pageUrl}
        image={`${siteUrl}/assets/images/about/about.webp`}
        structuredData={structuredData}
      />
      <PageHeader title={t("Galeri")} />
      <Galeri />
    </>
  );
}

export default GaleriPage;